import { render, staticRenderFns } from "./TrainingsViewPage.vue?vue&type=template&id=5b6a86aa&scoped=true"
import script from "./TrainingsViewPage.vue?vue&type=script&lang=js"
export * from "./TrainingsViewPage.vue?vue&type=script&lang=js"
import style0 from "./TrainingsViewPage.vue?vue&type=style&index=0&id=5b6a86aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a86aa",
  null
  
)

export default component.exports